import axios from "axios";
import API_BASE_URL from "src/config/apiConfig";
import { getApiKey, getTenantId } from "src/utils/getters";

export interface PipelineRefresh {
  pipeline_uuid: string;
  last_run_completed_at: string;
  source: string; // ✅ new field from backend
}

export const getPipelineRefreshTime = async (): Promise<PipelineRefresh[]> => {
  const tenant_id = getTenantId();
  const api_key = getApiKey();

  if (!tenant_id || !api_key) {
    throw new Error("Missing tenant ID or API key in localStorage");
  }

  const response = await axios.get(
    `${API_BASE_URL}/mage/get-pipelines-run-time`,
    {
      params: {
        tenant_id,
        api_key,
      },
    }
  );

  return response.data;
};

// Cancel data loading
export const cancelDataLoading = async (tenant_id: string, api_key: string) => {
  const response = await axios.post(
    `${API_BASE_URL}/tenant/cancel-data-load?tenant_id=${tenant_id}`,
    {},
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${api_key}`,
      },
    }
  );

  return response;
};

// Fetch shopify data loading status
export const fetchShopifyDataStatus = async (
  tenant_id: string,
  api_key: string
) => {
  const response = await fetch(
    `${API_BASE_URL}/shopify/fetched-data-status?tenant_id=${tenant_id}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${api_key}`,
      },
    }
  );

  if (!response.ok) {
    throw new Error("Failed to fetch shopify data status");
  }

  const data = await response.json();
  return data;
};
